import { URI_PARAMETER_KEYS } from "config/router";
import useAppContext from "utilities/hooks/useAppContext";
import BookingDatalist, { BookingDatalistPropsType } from "components/entities/accommodation/booking/BookingDatalist";
import { uuid } from "config/app-constants";
import { Conditions, DatalistFilterDefinitions } from "utilities/datalist/datalist-filter-utilities";
import { DatalistDataSourceFilterType } from "types/datalist-types";
import { useParams } from "react-router-dom";

const BookingDatalistPrintPage = () => {
    const { [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: targetSeasonId } = useParams<{ [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: string }>();
    const context = useAppContext();

    let filter: DatalistDataSourceFilterType | undefined = undefined;
    if (!targetSeasonId) {
        filter = {
            id: uuid(),
            logic: 'and',
            filters: [
                DatalistFilterDefinitions.seasonFilterDefinition(context),
                {
                    id: uuid(),
                    name: 'isCancelled',
                    type: 'boolean',
                    condition: Conditions.eq,
                    value: false
                },
                {
                    id: uuid(),
                    name: 'status',
                    type: 'reference',
                    condition: Conditions.eq,
                    value: 'staingAndFuture'
                }
            ]
        }
    }

    const bookingDatalistConfig: BookingDatalistPropsType = {
        name: "pages-accommodation-booking-list",
        hasBottomNavigation: false,
        hideColumns: ['isCancelled', 'season'],
        hideTotalRow: true,
        config: {
            dataSource: {
                filter
            },
            table: {
                render: {
                    actions: () => undefined
                }
            },
            page: 'off'
        },
        fixedFilters: !targetSeasonId ? undefined : {
            seasonId: {
                eq: Number(targetSeasonId)
            }
        }
    }

    return (
        <BookingDatalist {...bookingDatalistConfig} />
    );
};

export default BookingDatalistPrintPage;
